import styled from 'styled-components'

import { rgba } from 'polished'

export const Paragraph = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  color: ${({ theme }) => rgba(theme.colors.black, 0.65)};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  letter-spacing: -0.07px; /* stylelint-disable-line scales/letter-spacing */
  line-height: 1.5;

  strong {
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    color: ${({ theme }) => theme.colors.black};
  }
`

export const Section = styled.div`
  padding: ${({ theme }) => theme.space[8]}px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.dark.base};

  :last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`
